export const PERMISSOES_DASHBOARD = {
  associados: 'associado:listar',
  beneficiarios: 'beneficiario:listar',
  bens: 'bem:listar',
  eventos: 'evento:listar',
  boletos: 'financeiro:ver',
  inadimplencia: 'receber:ver',
  migracao: 'migracao:ver',
} as const
